import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { AttributeTypeItem } from 'types/pricingSimulator';
import { CustomSelect } from './PricingSimulator/DimSection';
import { Tag } from 'antd';
import { DropdownItem } from 'types/tradePromoOptimization';

type Props = {
    disabled?: boolean;
    onPopupClose: (tempSelectedDimensionList: DropdownItem[]) => void;
    dropdownList: DropdownList;
    selectedDropdownItems: DropdownItem[];
    style?: React.CSSProperties;
    className?: string;
    onChange: (val: any, item: any, setTempSelectedDimensionList: Dispatch<SetStateAction<DropdownItem[]>>) => void;
};

type DropdownList = { label: string; options: DropdownItem[] }[];

const MultiSelectDropdown: FC<Props> = ({
    selectedDropdownItems,
    disabled,
    dropdownList,
    onPopupClose,
    style,
    onChange,
    className,
}) => {
    const [tempSelectedDimensionList, setTempSelectedDimensionList] = useState<DropdownItem[]>([]);

    //when dropdown value changes, update in component state as well
    //this is useful to auto populate default values
    useEffect(() => {
        setTempSelectedDimensionList(selectedDropdownItems ?? []);
    }, [selectedDropdownItems]);

    return (
        <div>
            <CustomSelect
                className={className}
                disabled={disabled}
                style={style}
                mode="multiple"
                placeholder="Multiple Select"
                maxTagCount="responsive"
                //   maxTagCount={2}
                tagRender={(val) => {
                    return (
                        <Tag className="rounded" closable={false}>
                            {val?.label}
                        </Tag>
                    );
                }}
                //  maxTagTextLength={7}
                showArrow
                onDropdownVisibleChange={(open) => {
                    if (!open) {
                        onPopupClose(tempSelectedDimensionList);
                    }
                }}
                showSearch={false}
                value={tempSelectedDimensionList?.map((item) => item?.value)}
                onChange={(val: any, item: any) => {
                    onChange(val, item, setTempSelectedDimensionList);
                }}
                options={dropdownList}
            />
        </div>
    );
};

export default MultiSelectDropdown;
